/* eslint-disable */

if (typeof window !== 'undefined')
  __webpack_nonce__ = window.__NONCE__;
